import React, { Component } from 'react';
import { FormattedMessage } from "react-intl";
import Picture from '../../Picture'

class HomepageExpertTeam extends Component
{
    container = React.createRef()
    parallax = React.createRef()

    componentDidMount() {
        window.addEventListener('scroll', this.onScroll)
        this.onScroll()
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll)
    }

    onScroll = (e) => {
        const scrollY = window.scrollY
        const delta = scrollY / this.container.current.offsetHeight
        this.parallax.current.style.marginTop = Math.round(60 * delta - 300) + 'px'
    }

    render() {
        return (
            <section className="section-default section-experts-team" ref={this.container}>
                <div className="section-default-after section-experts-team-after" ref={this.parallax}/>
                <div className="container">
                    <div className="default-wrap experts-team-wrap">
                        <div className="experts-team-img" />
                        <div className="default-text experts-team-text">
                            <h2>
                                <FormattedMessage
                                    id="portfolio.homepage.experts_team.title"
                                    defaultMessage=""
                                />
                            </h2>
                            <p className="default-text-subtitle experts-team-text-subtitle">
                                <FormattedMessage
                                    id="portfolio.homepage.experts_team.subtitle"
                                    defaultMessage=""
                                />
                            </p>
                            <p className="default-text-paragraph experts-team-text-paragraph">
                                <FormattedMessage
                                    id="portfolio.homepage.experts_team.paragraph_1"
                                    defaultMessage=""
                                />
                            </p>
                            <p className="default-text-paragraph experts-team-text-paragraph">
                                <FormattedMessage
                                    id="portfolio.homepage.experts_team.paragraph_2"
                                    defaultMessage=""
                                />
                            </p>
                            <p className="default-text-paragraph experts-team-text-paragraph">
                                <FormattedMessage
                                    id="portfolio.homepage.experts_team.paragraph_3"
                                    defaultMessage=""
                                />
                            </p>

                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default HomepageExpertTeam;
